import React from "react";
import PageHeader from "@/components/PageHeader";
import FooterBar from "@/components/FooterBar";
import useSeo from "@/lib/useSeo";

// Shared layout for all policy / disclosure pages.
//
// SEO: forwards ``title`` + ``description`` to ``useSeo`` so every policy
// page gets a unique <title>, meta description, og:url, and canonical
// link automatically. Pages can override SEO copy via the ``seoTitle`` /
// ``seoDescription`` props when the visible H1 isn't the best search
// keyword (e.g., "Privacy Notice" vs "Insurance Privacy Notice").
export default function PageShell({
    title,
    kicker,
    lastUpdated,
    children,
    testId,
    seoTitle,
    seoDescription,
}) {
    useSeo({
        title: seoTitle || title,
        description: seoDescription,
    });

    return (
        <main
            data-testid={testId || "policy-page"}
            className="relative min-h-screen bg-brand-bg text-brand-ivory"
        >
            <PageHeader />

            <article className="mx-auto max-w-3xl px-6 pb-20 pt-12 md:px-10 md:pb-28 md:pt-16">
                {kicker && (
                    <p className="text-[11px] uppercase tracking-[0.4em] text-brand-goldSoft">
                        {kicker}
                    </p>
                )}
                <h1 className="mt-4 font-serif text-4xl leading-tight text-brand-ivory sm:text-5xl">
                    {title}
                </h1>
                {lastUpdated && (
                    <p className="mt-3 text-xs text-brand-muted">
                        Last updated: {lastUpdated}
                    </p>
                )}
                <div className="gold-hairline my-8 w-32" />
                <div className="prose-policy space-y-6 text-base leading-relaxed text-brand-ivory/90">
                    {children}
                </div>
            </article>

            <FooterBar />
        </main>
    );
}
